import {
  Bank,
  File,
  FileArchive,
  House,
  Lock,
  TrademarkRegistered,
  UserCheck,
} from "@phosphor-icons/react";
import { Outlet } from "react-router-dom";
import { app } from "src/routes/app";
import { useAccessControl } from "src/routes/context/AccessControl";
import { Header } from "../Header/Header";
import { SidebarX } from "../Sidebar/SidebarX";
import { BallonEditPrice } from "./BallonEditPrice";

export const LayoutX = () => {
  const { acesso } = useAccessControl();

  const nav = [
    {
      text: "Início",
      route: app.home,
      icon: <House width={20} height={17} weight="duotone" />,
    },
    {
      text: "Segurança",
      route: app.security,
      icon: <Lock width={20} height={17} weight="duotone" />,
    },
    // Itens visíveis apenas se acesso usuário for User ou Master
    ...(["Bank", "Master"].includes(acesso)
      ? [
          {
            text: "Banco",
            route: app.bank,
            icon: <Bank width={20} height={17} weight="duotone" />,
          },
        ]
      : []),
    // Itens visíveis apenas se acesso !== 'User'
    ...(!["User", "Bank"].includes(acesso)
      ? [
          {
            text: "Usuários",
            route: app.users,
            icon: <UserCheck width={20} height={17} weight="duotone" />,
          },
          {
            text: "Ordens",
            route: app.registerOrders,
            icon: <TrademarkRegistered width={20} height={17} weight="duotone" />,
          },
          {
            text: "Contratos",
            route: app.documentsGenerator,
            icon: <File width={20} height={17} weight="duotone" />,
          },
          {
            text: "Conversão",
            route: app.convert,
            icon: <FileArchive width={20} height={17} weight="duotone" />,
          },
        ]
      : []),
  ];

  return (
    <div className="flex h-full max-h-fit w-full flex-col">
      <Header navbar={nav} />
      <div className="flex w-full">
        <SidebarX navbar={nav} />
        <div className="flex max-h-full min-h-screen w-full flex-col gap-2 bg-gray-400 p-6 md:h-full md:gap-4">
          <Outlet />
          {acesso === "Master" && <BallonEditPrice />}
        </div>
      </div>
    </div>
  );
};
